<template>
  <!-- layout contents -->
  <div class="container">
    <div class="users-list flex-col mar-top-50">
      <!-- TOp part -->
      <div class="flex-row-align-center mar-bottom-50">
        <PageHeading
          :title="`Settings`"
          :description="
            'All the controls and management settings of your account'
          "
        />
      </div>
    </div>
    <div class="tabbed-card mar-bottom-50 smooth-shadow">
      <ul class="tab-area smooth-shadow">
        <li
          v-for="tab in tabs"
          :key="tab.id"
          @click="activeTab = tab.id"
          :class="[{ active: activeTab === tab.id }]"
        >
          <i class="material-icons md-18 mar-right-10">{{ tab.icon }}</i
          >{{ tab.name }}
        </li>
      </ul>
      <div class="tab-contents">
        <AccountSettings v-if="activeTab === 'account'" />
        <Preferences v-if="activeTab === 'preferences'" />
      </div>
    </div>
  </div>
</template>

<script>
import AccountSettings from "@/components/settings/forms/AccountSettings";
import Preferences from "@/components/settings/forms/Preferences";

export default {
  components: {
    AccountSettings,
    Preferences,
  },
  data() {
    return {
      activeTab: "account",
      tabs: [
        {
          name: "Account settings",
          id: "account",
          icon: "person",
        },
        {
          name: "Preferences",
          id: "preferences",
          icon: "tune",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.tabbed-card {
  display: flex;
  flex-direction: column;
  background: var(--color-secondary);
  border-radius: 5px;

  .tab-area {
    padding: 5px 15px 0 15px;
    list-style-type: none;
    margin: 0;
    display: flex;
    align-items: center;
    z-index: 10;

    li {
      margin: 0;
      padding: 10px 15px 15px 15px;
      border-radius: 5px 5px 0 0;
      border-bottom: 2px solid var(--color-transparent);
      display: flex;
      align-items: center;

      &:hover {
        cursor: pointer;
        background-color: var(--color-primary-light);
      }

      &.active {
        border-bottom: 2px solid var(--color-primary);
        color: var(--color-primary);
      }
    }
  }

  .tab-contents {
    min-height: 300px;
    background: var(--color-secondary-light);
  }
}
</style>
